import * as React from "react"
import {Form} from "semantic-ui-react"
import {CountryCode, formatNumber, parseNumber} from "libphonenumber-js"
import {isEmptyObject} from "../tsutil"

const defaultCountry: CountryCode = "AU"

export function isValidPhoneNumber(text: string) {
  // This is just a basic verification, see also the docs on the stricter
  // isValidNumber in libphonenumber-js.
  return !isEmptyObject(parseNumber(text, defaultCountry))
}

export function formatMobile(text: string): string {
  const phoneNumber = parseNumber(text, defaultCountry)

  if (isEmptyObject(phoneNumber)) {
    throw Error("You cannot format an invalid mobile phone number.")
  }
  return formatNumber(phoneNumber, "International")
}

interface OwnProps {
  label: string
  phoneNumber: string
  onChange: (x: string) => void
  required: boolean
  error?: boolean
}

export function PhoneField({label, phoneNumber, onChange, required, error}: OwnProps) {
  return (
    <Form.Field required={required} error={error}>
      <label>{label}</label>
      <Form.Input
        value={phoneNumber}
        type="tel"
        placeholder="Phone number"
        onChange={(e, field) => {
          onChange(field.value)
        }}
      />
    </Form.Field>
  )
}



// WEBPACK FOOTER //
// ./src/components/PhoneField.tsx